import * as React from "react"

import MuiCard from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

import getQuery from "../utils/query"
import { CalculatorBaseProps } from "./types"

type CardProps = CalculatorBaseProps

const Card: React.FC<CardProps> = ({ children, ...props }) => {
    const { width = "auto", title = "", description = "" } = getQuery(props)
    const theme = useTheme()

    const _title = title
    const _description = description
    const hasHeader = Boolean(_title || _description)
    return (
        <MuiCard
            variant="outlined"
            style={{
                width,
                padding: theme.spacing()
            }}>
            <CardContent component="form">
                {hasHeader ? (
                    <div style={{ marginBottom: theme.spacing(2) }}>
                        {_title ? (
                            typeof _title === "string" ? (
                                <Typography
                                    variant="h3"
                                    component="h2">
                                    {_title}
                                </Typography>
                            ) : (
                                _title
                            )
                        ) : null}
                        {_description ? (
                            typeof _description === "string" ? (
                                <Typography color="textSecondary">
                                    {_description}
                                </Typography>
                            ) : (
                                _description
                            )
                        ) : null}
                    </div>
                ) : null}
                {children}
            </CardContent>
        </MuiCard>
    )
}

export default Card
